var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3302 0.615234H1.64932C1.07815 0.615578 0.61512 1.07883 0.615234 1.65024V18.3311C0.615578 18.9023 1.07883 19.3653 1.65024 19.3652H10.6311V12.1143H8.1958V9.27612H10.6311V7.18746C10.6311 4.76532 12.1098 3.44696 14.2704 3.44696C15.3053 3.44696 16.1946 3.52409 16.4539 3.55854V6.09009H14.964C13.7884 6.09009 13.5608 6.64867 13.5608 7.46853V9.27612H16.3715L16.0052 12.1143H13.5608V19.3652H18.3302C18.9017 19.3653 19.3651 18.9022 19.3652 18.3307C19.3652 18.3306 19.3652 18.3305 19.3652 18.3302V1.64932C19.365 1.07815 18.9016 0.61512 18.3302 0.615234Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5bc6ea61.svg";
export { ForwardRef as ReactComponent };